import {MoveDrawer} from '@app/modules/svg/service/tool/draw/mode/MoveDrawer';
import {Point} from '@app/modules/svg/model/Point';
import {MoveDrawable} from '@app/modules/svg/service/tool/draw/type/MoveDrawable';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';
import {PrismView} from '@app/modules/svg/element/shape/pointed/projected-3d/PrismView';

export class DrawPrism extends MoveDrawer {
  public baseVertexCount: number = 5;

  protected createDrawableElement(position: Point): MoveDrawable {
    return new PrismView(this.drawTool.container, {overEvent: true, globalStyle: true, baseVertexCount: this.baseVertexCount}, {x: position.x, y: position.y, width: 1, height: 1});
  }

  public override start(call: boolean = true): void {
    super.start(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.PRISM_TOOL_ON);
    }
  }
  public override stop(call: boolean = true): void {
    super.stop(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.PRISM_TOOL_OFF);
    }
  }

  public _new(): DrawPrism {
    return new DrawPrism(this.drawTool);
  }
  public get type(): ElementType {
    return ElementType.PRISM;
  }
}
